import { render, staticRenderFns } from "./VideoCallScreen.vue?vue&type=template&id=0ec93d2d"
import script from "./VideoCallScreen.vue?vue&type=script&lang=js"
export * from "./VideoCallScreen.vue?vue&type=script&lang=js"
import style0 from "./VideoCallScreen.vue?vue&type=style&index=0&id=0ec93d2d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports